import { combineReducers } from 'redux'

import {
  SELECT_SHIPPING_METHOD,
  SELECT_PAYMENT_OPTION,
  COMPLETE_CHECKOUT,
  UPDATE_ITEM_QUANTITY,
  DELETE_ITEM,
  BRAINTREEE_PAYMENT_DATA_UPDATE,
  PURCHASE_ORDER_PAYMENT_DATA_UPDATE
} from '../actions'

import {
  Addresses,
  BillingAddresses,
  ShippingAddresses,
  SelectedBillingAddressId,
  SelectedShippingAddressId
} from './addressReducers'

import {
  useShippingForBilling,
  PhoneNumber,
  PhoneText,
  messages,
  completeCheckoutButtonText,
  isPlaceOrderPending,
  selectedPaymentLabel
} from './uiReducers'

import { replaceInList, removeFromList, removeFromListById } from './listUtility'

const CartItems = (state = [], action) => {
  switch(action.type) {
    case UPDATE_ITEM_QUANTITY:
      return state.map(item =>
        (item.Id === action.itemId)
        ? Object.assign({}, item, { Quantity: action.newQuantity })
          : item);
    case DELETE_ITEM:
      return removeFromListById(state, action.itemId);
  }
  return state;
}

function OrderNumber(state = 0, action) {
  return state;
}

function PaymentOptions(state = [], action) {
  return state;
}

function SelectedPaymentOptionId(state = '', action) {
  switch (action.type) {
    case SELECT_PAYMENT_OPTION:
      return action.paymentMethodId || '';
  }
  return state;
}

function ShippingOptions(state = [], action) {
  return state;
}

function SelectedShippingOptionId(state = '', action) {
  switch(action.type) {
    case SELECT_SHIPPING_METHOD:
      return action.shippingMethodId
  }
  return state;
}

function SubTotal(state = 0, action) {
  return state;
}

const emptySummary = { Total: 0, SubTotal: 0, ShippingTotal: 0, Currency: 'USD', TotalRemaining: 0}

function Summary(state = emptySummary, action) {
  if (typeof state.TotalRemaining === 'undefined')
    state = Object.assign({}, state, { TotalRemaining: state.Total });
  return state;
}

function PaymentRecord(state = {}, action) {
  switch(action.type) {
      case BRAINTREEE_PAYMENT_DATA_UPDATE:
          return Object.assign({}, state, { BraintreePaymentNonce: action.payload && action.payload.nonce, DeviceData: action.payload.deviceData });
    case PURCHASE_ORDER_PAYMENT_DATA_UPDATE:
      return Object.assign({}, state, { POValue: action.number });
  }
  return state;
}

const entities = combineReducers({
  Addresses,
  BillingAddresses,
  SelectedBillingAddressId,
  ShippingAddresses,
  SelectedShippingAddressId,
  CartItems,
  OrderNumber,
  PaymentOptions,
  SelectedPaymentOptionId,
  ShippingOptions,
  SelectedShippingOptionId,
  SubTotal,
  Summary,
  PaymentRecord
});

const ui = combineReducers({
  useShippingForBilling,
  PhoneNumber,
  PhoneText,
  messages,
  completeCheckoutButtonText,
  isPlaceOrderPending,
  selectedPaymentLabel
});

function constants(state = {}, action) {
  return state; // they're constants. duh.
};

export const checkoutApp = combineReducers({
  ui,
  entities,
  constants
});



// WEBPACK FOOTER //
// ./src/Components/checkout/reducers/reducers.js